export interface User {
	userId?: string;
	role?: number;
	userName?: string;
	is2faEnabled: boolean;
}

export interface LoginRequest {
	email: string;
	password: string;
}

export interface TwoFactorSetup {
	qrCodeUri: string;
	secret: string;
}

export class ApiError extends Error {
	status: number;
	data: unknown;

	constructor(status: number, message: string, data?: unknown) {
		super(message);
		this.status = status;
		this.data = data;
	}
}

export enum ImportStatus {
	Processing = 0,
	Succeeded = 1,
	Failed = 2,
}

export interface UploadStatus {
	status: ImportStatus;
	detail: string | null;
}
